import { render } from "./GroupsPage.vue?vue&type=template&id=703b9b4b&scoped=true&ts=true"
import script from "./GroupsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupsPage.vue?vue&type=script&lang=ts&setup=true"

import "./GroupsPage.vue?vue&type=style&index=0&id=703b9b4b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703b9b4b"],['__file',"src/pages/settings/pages/groups/GroupsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "703b9b4b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('703b9b4b', __exports__)) {
    api.reload('703b9b4b', __exports__)
  }
  
  module.hot.accept("./GroupsPage.vue?vue&type=template&id=703b9b4b&scoped=true&ts=true", () => {
    api.rerender('703b9b4b', render)
  })

}


export default __exports__